module.exports = __webpack_public_path__ + "img/50.7614f726.gif";